// extracted by mini-css-extract-plugin
export var cartContainer = "_oa-4";
export var gray = "_oa-1";
export var itemContainer = "_oa-2";
export var itemDetails = "_oa-3";
export var strong = "_oa-0";